import { ChevronDown } from "lucide-react";

/**
 * SectionFold — reusable collapsible section header used by SuspectEditor,
 * LeadEditor, and any future "long form with sections" editor.
 */
export function SectionFold({ section, open, onToggle, children, testIdPrefix = "section" }) {
  const Icon = section.icon;
  return (
    <div
      className="hv-card overflow-hidden"
      style={{ borderColor: open ? `${section.accent}40` : "rgba(255,255,255,0.05)" }}
      data-testid={`${testIdPrefix}-${section.key}`}
    >
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-3 px-3 py-2.5 hover:bg-white/[0.03] text-left"
        style={{ background: open ? `${section.accent}0a` : "transparent" }}
        data-testid={`${testIdPrefix}-toggle-${section.key}`}
      >
        <span className="flex items-center gap-2">
          {Icon && <Icon className="w-4 h-4" style={{ color: section.accent }} />}
          <span className="text-sm font-bold" style={{ color: section.accent }}>{section.title}</span>
        </span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} style={{ color: section.accent }} />
      </button>
      {open && <div className="px-3 pb-3 pt-2 space-y-2.5">{children}</div>}
    </div>
  );
}

export function Field({ label, children, half, full }) {
  return (
    <div className={`min-w-0 ${full ? "md:col-span-2" : half ? "" : "md:col-span-2"}`}>
      <div className="text-[10px] uppercase tracking-wider text-[#647087]">{label}</div>
      {children}
    </div>
  );
}
